module.exports = __webpack_public_path__ + "static/media/c1e27035-2b32-446d-9be0-ac517cf29e62.f843fe5b.jpeg";